import axios from 'axios'

export default class MetricsService {
    measureKlassenmap() {
        return axios.post(`/api/Frontend/Metrics/Klassenmap`)
    }
}

export const metricsService: MetricsService = new MetricsService()
